(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var sectionRoot = document.querySelector('[data-cart-drawer-section]');

  function updateCounts(count) {
    document.querySelectorAll('.gc-header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    var drawerCount = document.getElementById('drawer-cart-count');
    if (drawerCount) drawerCount.textContent = count;
  }

  function refreshDrawer() {
    if (!sectionRoot) return Promise.resolve();
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var temp = document.createElement('div');
          temp.innerHTML = data['cart-drawer'];
          var sectionEl = temp.querySelector('.shopify-section');
          sectionRoot.innerHTML = sectionEl ? sectionEl.innerHTML : data['cart-drawer'];
          bindDrawerEvents();
        }
      })
      .catch(function () {});
  }

  function bindDrawerEvents() {
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.__cartDrawer.close();
      });
    });

    document.querySelectorAll('[data-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-cart-qty'), 10);
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        changeLine(line, qty);
      });
    });
  }

  function changeLine(line, quantity) {
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCounts(cart.item_count);
        return refreshDrawer();
      })
      .catch(function (err) {
        console.error('Cart update failed:', err);
      });
  }

  window.__cartDrawer = {
    open: function () {
      if (!drawer || !overlay) return;
      drawer.classList.add('gc-cart-drawer--open');
      overlay.classList.add('gc-cart-overlay--visible');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gc-cart-open');
    },
    close: function () {
      if (!drawer || !overlay) return;
      drawer.classList.remove('gc-cart-drawer--open');
      overlay.classList.remove('gc-cart-overlay--visible');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gc-cart-open');
    },
    toggle: function () {
      if (drawer && drawer.classList.contains('gc-cart-drawer--open')) {
        this.close();
      } else {
        this.open();
      }
    }
  };

  if (overlay) {
    overlay.addEventListener('click', function () {
      window.__cartDrawer.close();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      window.__cartDrawer.close();
      document.querySelector('.gc-header__search-panel')?.classList.remove('is-open');
    }
  });

  document.querySelectorAll('[data-gc-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      refreshDrawer().then(function () {
        window.__cartDrawer.open();
      });
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-gc-atc-form]')) return;
    e.preventDefault();

    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10);
    var qty = parseInt(fd.get('quantity'), 10) || 1;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCounts(cart.item_count);
        return refreshDrawer();
      })
      .then(function () {
        window.__cartDrawer.open();
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        form.submit();
      });
  });

  bindDrawerEvents();
})();
